import { Button } from '@echo/ui-web';
import { Trans } from '@lingui/react/macro';
import { createFileRoute, Link } from '@tanstack/react-router';
import { AboutStory } from '@/components/about-story';
import { ToolbarBack } from '@/components/empty-state-frame';

export const Route = createFileRoute('/_app/account_/about')({ component: AccountAboutPage });

/**
 * Account › About StrongerMemory: the same letter as the welcome, inside
 * a white frame with the "About StrongerMemory" eyebrow, "← Back" above and "Back to account"
 * on the band below.
 */
function AccountAboutPage() {
  return (
    <>
      <ToolbarBack
        render={({ className, children }) => (
          <Link to="/account" className={className}>
            {children}
          </Link>
        )}
      />
      <article className="flex w-full flex-col overflow-hidden rounded-xxl bg-surface">
        <div className="flex flex-col gap-content-sm px-content-sm pt-section-lg sm:px-section-lg">
          <p className="text-label-md text-on-surface-highlight">
            <Trans>About StrongerMemory</Trans>
          </p>
          <AboutStory />
        </div>
        <div className="mt-content-lg flex w-full justify-end bg-surface/60 px-content-sm pt-content-lg pb-section-sm">
          <Link to="/account">
            <Button tabIndex={-1}>
              <Trans>Back to account</Trans>
            </Button>
          </Link>
        </div>
      </article>
    </>
  );
}
